import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";

function locationGroupKey(
  productId,
  search,
  locationId,
  zoneId,
  productTypeId,
) {
  return `${productId}|${search || ""}|${locationId || ""}|${zoneId || ""}|${productTypeId || ""}`;
}

function cartonKey(productId, locationId, zoneId, search, productTypeId) {
  const zone = zoneId == null || zoneId === "" ? "none" : zoneId;
  return `${productId}|${locationId}|${zone}|${search || ""}|${productTypeId || ""}`;
}

export function InventoryManufacturedMaterialViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState({ data: [] });
  const [subRowDetails, setSubRowDetails] = useState({});
  const [cartonDetails, setCartonDetails] = useState({});
  const [loadingRows, setLoadingRows] = useState({});
  const [loadingCartons, setLoadingCartons] = useState({});

  const getInStockRawMaterial = async function (
    search,
    page,
    locationId,
    zoneId,
    productTypeId,
  ) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      location_id: locationId || null,
      zone_id: zoneId || null,
      product_type_id: productTypeId || null,
    };
    let callResult = await makePostApiCall(
      "inventoryManufacturedMaterial",
      payload,
    );

    if (callResult.success) {
      setProducts(callResult.data);
    } else if (callResult.errorStatus === 401) {
      logout();
    }
    setLoading(false);
  };

  const fetchSubRowDetails = async function (
    rowData,
    search,
    locationId,
    zoneId,
    productTypeId,
  ) {
    const key = locationGroupKey(
      rowData.product_id,
      search,
      locationId,
      zoneId,
      productTypeId,
    );
    const payload = {
      product_id: rowData.product_id,
      search: search,
      location_id: locationId || null,
      zone_id: zoneId || null,
      product_type_id: productTypeId || null,
    };

    setLoadingRows((prev) => ({
      ...prev,
      [key]: true,
    }));

    let callResult = await makePostApiCall(
      "inventoryManufacturedSubItem",
      payload,
    );

    setLoadingRows((prev) => ({
      ...prev,
      [key]: false,
    }));

    if (callResult.success) {
      setSubRowDetails((prev) => ({
        ...prev,
        [key]: callResult.data,
      }));
    } else if (callResult.errorStatus === 401) {
      logout();
    }
  };

  const fetchCartons = async function (group, search, productTypeId) {
    const key = cartonKey(
      group.product_id,
      group.location_id,
      group.zone_id,
      search,
      productTypeId,
    );
    const payload = {
      product_id: group.product_id,
      location_id: group.location_id,
      zone_id: group.zone_id || null,
      search: search,
      product_type_id: productTypeId || null,
    };

    setLoadingCartons((prev) => ({
      ...prev,
      [key]: true,
    }));

    let callResult = await makePostApiCall(
      "inventoryManufacturedCartons",
      payload,
    );

    setLoadingCartons((prev) => ({
      ...prev,
      [key]: false,
    }));

    if (callResult.success) {
      setCartonDetails((prev) => ({
        ...prev,
        [key]: callResult.data,
      }));
    } else if (callResult.errorStatus === 401) {
      logout();
    }
  };

  const exportNetsuiteInventoryAdjustmentCsv = async function () {
    let callResult = await makePostApiCall(
      `exportNetsuiteInventoryAdjustmentCsv`,
    );
    if (callResult.success) {
      window.open(callResult.data.location, "_blank").focus();
    } else if (callResult.errorStatus === 401) {
      logout();
    }
  };

  return {
    getInStockRawMaterial,
    loading,
    products,
    exportNetsuiteInventoryAdjustmentCsv,
    fetchSubRowDetails,
    fetchCartons,
    loadingRows,
    loadingCartons,
    subRowDetails,
    cartonDetails,
    locationGroupKey,
    cartonKey,
  };
}
